// ChatShell.jsx
import {Box, Container, HStack, Text} from "@chakra-ui/react";

export default function ChatShell({roomName, headerActions, renderMessages, renderInput, rightSidebar}) {
  return (
    <Box
      bg="gray.50"
      display="grid"
      gridTemplateRows="auto 1fr"
      minH={{
      base: "100dvh",
      md: "100vh"
    }}
      h={{
      base: "100dvh",
      md: "100vh"
    }}
      overflow="hidden">
      {/* 頂部列 */}
      <Box
        position="sticky"
        top={0}
        zIndex={10}
        bgGradient="linear(to-r, purple.200, purple.300)"
        boxShadow="sm">
        <Container maxW="6xl" py={2}>
          <HStack justify="space-between">
            <Text fontSize="xl" fontWeight="bold" color="gray.800">
              {roomName}
            </Text>
            <HStack>{headerActions}</HStack>
          </HStack>
        </Container>
      </Box>

      {/* 主內容 */}
      <Box minH={0} h="100%" overflow="hidden">
        <Container
          maxW="6xl"
          py={6}
          h="100%"
          display="flex"
          flexDirection="column"
          minH={0}>
          <Box
            flex="1"
            minH={0}
            display="grid"
            gridTemplateColumns={{
            base: "1fr",
            md: rightSidebar
              ? "1fr 280px"
              : "1fr"
          }}
            gap={6}
            overflow="hidden">
            {/* 左側：聊天卡片 */}
            <Box

              display="flex" flexDirection="column"
              bg="white"
              borderRadius="xl"
              boxShadow="md"
              h="100%"
              minH={0}
              overflow="hidden">
              {/* 標題 */}
              <Box px={5} py={3} borderBottom="1px solid" borderColor="gray.200">
                <Text fontSize="lg" fontWeight="semibold" color="gray.800">
                  聊天內容
                </Text>
              </Box>

              {/* 訊息區插槽 */}
              <Box
                ref={null}
                overflowY="auto"
                flex="1"
                minH="160px" 
                style={{
                overscrollBehavior: 'contain',
                scrollbarGutter: 'stable'
              }}
                px={5}
                py={4}
                bg="gray.50">
                {renderMessages()}
              </Box>

              {/* 底部輸入插槽 */}
              <Box
                px={5}
                py={3}
                pb={{
                base: "max(12px, env(safe-area-inset-bottom))",
                md: 3
              }}
                bg="rgba(255,255,255,0.85)"
                backdropFilter="saturate(120%) blur(6px)"
                borderTop="1px solid"
                borderColor="gray.100">
                {renderInput()}
              </Box>
            </Box>

            {/* 右側成員欄插槽 */}
            {rightSidebar && (
              <Box
                display={{ base: 'none', md: 'block' }}
                bg="white"
                borderRadius="xl"
                boxShadow="sm"
                h="100%"
                minH={0}
                overflow="hidden">
                {rightSidebar}
              </Box>
            )}
          </Box>
        </Container>
      </Box>
    </Box>
  );
}
